var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cluster-objects-scroll scroll-fire-fox" },
    [
      _vm.clusterTool && _vm.selectedObjects.length > 0
        ? _c("span", { staticClass: "mb-1 font-weight-bold" }, [
            _vm._v("Initial Closure:")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.selectedObjects, function(object, index) {
        return _c("div", { key: object.uuid }, [
          _c(
            "div",
            {
              staticClass: "floating-object-selected",
              class: { "main-closure": index === 0 && _vm.clusterTool }
            },
            [
              _c("img", {
                staticClass: "floating-img",
                attrs: {
                  src: require("@/assets/objectIcons/" +
                    object.type.toLowerCase() +
                    ".png")
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: { "text-align": "left", "padding-right": "5px" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.objectIdentification(object)) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              object.max_hp
                ? _c("div", { staticClass: "cluster-object-hps" }, [
                    _vm._v("\n        " + _vm._s(object.max_hp) + "\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectionType === "point" || _vm.clusterTool
                ? _c(
                    "div",
                    {
                      staticClass: "floating-hover-options",
                      on: {
                        click: function($event) {
                          return _vm.openObjectMenu($event, object)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("more_vert")])],
                    1
                  )
                : _vm._e()
            ]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db0f102c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db0f102c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/Cluster/SelectedObjects.vue
// module id = null
// module chunks = 